"use strict";
const _ = require("lodash");
const BaseSingleOptionSelectionControlComponent = require("@gluenetworks/input_base_control")
    .OptionSelection.Single;
const Renderer = require("./SingleSelectListControlRenderer");

class SelectListControlComponent extends BaseSingleOptionSelectionControlComponent {
    /**
     * @schema.name Select List Control
     * @schema.package @gluenetworks/select_list
     * @schema.packageIdentifier Single
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.SelectList
     * @schema.events ["Options", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.options.example [{ label: 'Number 1', value: { valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } }, disabled: true },{ label: 'Number 2', value: { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } } },{ label: 'Number 3', value: { valueProp1: 'blah3', valueProp2: { somethin: 'somethin3' } }, disabled: true },{ label: 'Number 4', value: { valueProp1: 'blah4', valueProp2: { somethin: 'somethin4' } } },{ label: 'Number 5', value: { valueProp1: 'blah5', valueProp2: { somethin: 'somethin5' } } }]
     *
     * @schema.configuration.value.example { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } }
     *
     */

    constructor(configOptions) {
        super(configOptions);
        // optionIcon - can be a string or a function
        this._optionIcon = _.get(configOptions, "optionIcon", false);
        // selectedOptionIcon - can be a string or a function
        this._selectedOptionIcon = _.get(configOptions, "selectedOptionIcon", false);
        this._renderer = new Renderer(this);
        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    hasOptionIcons() {
        return _.isString(this._optionIcon) || _.isFunction(this._optionIcon);
    }
    getOptionIcon(optionValue) {
        let isSelected = _.isEqual(optionValue, this._value);
        if (isSelected) {
            return this.getSelectedOptionIcon(optionValue);
        }
        if (_.isString(this._optionIcon)) {
            return this._optionIcon;
        } else if (_.isFunction(this._optionIcon)) {
            return this._optionIcon(optionValue);
        } else {
            return "common.check";
        }
    }
    getSelectedOptionIcon(optionValue) {
        if (_.isString(this._selectedOptionIcon)) {
            return this._selectedOptionIcon;
        } else if (_.isFunction(this._selectedOptionIcon)) {
            return this._selectedOptionIcon(optionValue);
        } else {
            return "common.check";
        }
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._options = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._darkTheme = undefined;
        this._userSelected = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = SelectListControlComponent;
